export default {
  "Select All": "Seleccionar todo",
  "This field is required": "Este campo es obligatorio",
  "Add New Company": "Añadir nueva empresa",
  "COMPANY REGISTRATION": "REGISTRO DE LA EMPRESA",
  "COMPANY INFORMATION": "INFORMACIÓN DE LA EMPRESA",
  "SUBSCRIPTION LIST": "LISTA DE SUSCRIPCIONES",
  "Account": "Cuenta",
  "Switch to Old View": "Cambiar a vista anterior",
  "Messaging": "Mensajería",
  "Logout": "Cerrar sesión",
  "Total Hours Worked": "Total de horas trabajadas",
  "Total Distance": "Distancia total",
  "USER INFORMATION": "Información del usuario",
  "Driver Name": "Nombre del conductor",
  "Vehicle Name": "Nombre del vehiculo",
  "Upload": "Subir a",
  "No file selected": "Ningún archivo seleccionado",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Reset": "Reiniciar",
  "viewSample": "Ver muestra",
  "The email is not valid": "El email no es valido",
  "LOG BOOK": "Libro de registro",
  "Description": "Descripción",
  "Date (in UTC)": "Date (in UTC)",
  "VIEW DOCUMENT": "VER DOCUMENTO",
  "NEXT": "SIGUIENTE",
  "PREV": "Previa",
  "Actions": "Acciones",
  "Annotation": "Anotación",
  "Modified By": "Modificado por",
  "Version": "Versión",
  "ELD": "ELD",
  "OTHER": "OTRO",
  "Un authorized": "Sin autorización",
  "LOG IN": "INICIAR SESIÓN",
  "REGISTRATION": "REGISTRO",
  "Forgot password?": "Se te olvidó tu contraseña?",
  "Remember me": "Recuérdame",
  "Log in": "Iniciar sesión",
  "If your email address is registered with us, you will receive a password recovery link at your email address": {},
  "FDCSA info": "NB: Esto enviará archivos a FMCSA por Correo Electrónico y / o servicios web como se describe en el Apéndice A a la Subparte B de la Parte 395",
  "mail@gmail": {
    "com": "mail@gmail.com"
  },
  "email": "correo electronico",
  "EDIT DAILY LOG": "EDIT DAILY LOG",
  "Email": "Correo Electronico",
  "Send a Message": "Enviar un mensaje",
  "Select Drivers here": {},
  "Type": "Tipo",
  "Email or Employee Id": "Correo Electrónico o ID del empleado",
  "Logs": "Registros",
  "Start Time": "Hora de inicio",
  "End Time": "Fin del tiempo",
  "Assigned Driver": "Controlador asignado",
  "Co-Driver": "Copiloto",
  "Status": "Estado",
  "PREVIOUS": "ANTERIOR",
  "First Name": "Nombre de pila",
  "Last Name": "Apellido",
  "apology": "Nuestras disculpas",
  "page moved": "Esa página fue movida o eliminada.",
  "send feedback": "Envíenos sus comentarios",
  "here": "aquí",
  "DAILY LOG HISTORY": "HISTORIAL DE REGISTRO DIARIO",
  "MANAGE LOGS": "GESTIONAR REGISTROS",
  "selectWithDot": "Seleccionar...",
  "Choose Reseller": "Elegir distribuidor",
  "Reseller Users": "Usuarios revendedores",
  "Company Registration": "Registro de empresa",
  "Fleet Manager Information": "Información del administrador de flota",
  "Underwriter Information": "Información del asegurador",
  "WF": {
    "connect Account Information": "Información de la cuenta de WF.connect"
  },
  "Service Manager Information": "Información del administrador de servicios",
  "Test Company": "Empresa de prueba",
  "Commission Rate %": "% de tasa de comisión",
  "Discount %": "Descuento %",
  "Zoho Customer Id": "ID de Cliente Zoho",
  "Total cost per month $": "Costo total por mes $",
  "Commission Amount $": "Monto de la comisión $",
  "Suspend Billing": "Suspender facturación",
  "All the features under the subscription tier:": "All the features under the subscription tier:",
  "WL Billing Info": "Información de Facturación WL",
  "Additional Line Items": "Artículos Adicionales",
  "Choose Portal": "Elige Portal",
  "Enable additional line items": "Habilitar artículos adicionales",
  "Please select a portal to view billing info!": "¡Seleccione un portal para ver la información de facturación!",
  "Please select a Reseller to view billing info!": "¡Seleccione un revendedor para ver la información de facturación!",
  "SEARCH LOGS": "BÚSQUEDA DE REGISTROS",
  "Manage Debug Logs": "Administrar registros de depuración",
  "DEBUG LOG LISTING": "LISTADO DE REGISTRO DE DEPURACIÓN",
  "PENDING DEBUG LOG REQUESTS": "SOLICITUDES DE REGISTRO DE DEPURACIÓN PENDIENTES",
  "PULL DEBUG LOG": "EXTRAER REGISTRO DE DEPURACIÓN",
  "Pull Debug Log": "Extraer registro de depuración",
  "Subcriptions": "Suscripciones",
  "Check All": "Verificar todo",
  "Uncheck All": "Desmarcar todo",
  "Registration Date": "Fecha de registro",
  "Cost Per Truck $": "Costo por camión $",
  "Activate": "Activar",
  "Requested By": "Solicitado por",
  "Date Requested": "Fecha Solicitada",
  "Prepaid Expiration Date": "Fecha de Expiración Prepagada",
  "Monthly Minimum $": "Mínimo Mensual $",
  "Prepaid Amount": "Monto Prepagado",
  "Seperate DVIR only": "Solo DVIR Separado",
  "By Vehicle": "Por Vehículo",
  "By Driver": "Por Conductor",
  "Billing Type": "Tipo de facturación",
  "backLogin": "Volver a iniciar sesión",
  "commissionRate": "Tasa de comisión",
  "Date": "Fecha",
  "emailAddress": "Dirección de correo electrónico",
  "Export": "Exportar",
  "Forgot": "¿Olvidaste tu contraseña?",
  "ForgotHeading": "Le ayudaremos a restablecerlo y retomar el rumbo.",
  "goToInspections": "volver a Inspecciones",
  "forgotPassword": "Forgot password ?",
  "logo": "Logo",
  "parentProducer": "Revendedor principal",
  "Password": "Contraseña",
  "policyHolder": "Titular de la póliza",
  "resellerInformation": "Información del revendedor",
  "resellerName": "Nombre del revendedor",
  "resetPassword": "Restablecer la contraseña",
  "suspendCompany": "Suspender empresa",
  "theme": "Tema",
  "camera": {
    "camera_serial_no": "No. de serie",
    "camera_view": "Vista",
    "cameraStatus": "Estado",
    "cycle": "Ciclo",
    "date": "Fecha",
    "endDate": "Fecha de fin",
    "event_level": "Nivel",
    "event_type": "Tipo de evento",
    "Fleet": "Flotas",
    "lastConnectTime": "Última hora de conexión",
    "lastDisconnectTime": "Última hora de desconexión",
    "listHeading": "Cámara",
    "simState": "Estado de SIM",
    "startDate": "Fecha de inicio",
    "time": "Hora",
    "vehicle": "Vehículo",
    "tabs": {
      "dataUsage": "Uso de datos",
      "events": "Eventos"
    }
  },
  "footer": {
    "address": {
      "one": "Oficina corporativa",
      "two": "Oficina",
      "three": "Online"
    },
    "patent": "Patente pendiente",
    "copyright": "Derechos de autor 2020",
    "PrivacyLegal": "Privacidad y legal"
  },
  "manageProfile": {
    "editProfile": {
      "heading": "EDITAR PERFIL"
    }
  },
  "common": {
    deactivate: 'Desactivar',
    "Cell Phone": "Teléfono móvil",
    "Confirm Password": "Confirmar Contraseña",
    "resetPassword": "Restablecer la contraseña",
    "companyInfo": "Información de la empresa",
    "noDataAvailable": "No hay datos disponibles",
    "noOfTruck": "Número de camión",
    "subscriptionTier": "Nivel de suscripción",
    "adminProperty": "PROPIEDADES DEL ADMINISTRADOR",
    "costperTruck": "Costo por Camión (Global) $",
    "costPerTruckPrime": "Costo por Camión (Prime8 ELD) $",
    "costPerTruckXtreme": "Costo por Camión (Xtreme) $",
    "costperTruckFleet": "Costo por Camión (Fleet Xpress) $",
    "startDate": "Fecha de Inicio",
    "payButtonText": "Actualizar tarjeta ahora",
    "expiredContract": "Tu cuenta ha sido restringida. Por favor, actualiza la tarjeta o contacta a tu proveedor de servicios para activarla.",
    "expiredContractPay": "Tu cuenta ha sido restringida. Por favor, paga la factura pendiente o contacta a tu proveedor de servicios para activarla.",
    "payButtonTextPay": "Pagar ahora",
    "saveCCButtonTextPay": "Pagar ahora",
    "saveCCButtonText": "Actualizar tarjeta de crédito",
    "cardHolder": "Titular de la tarjeta",
    "updateCardDetails": "Actualizar tarjeta de crédito",
    "acceptPopup": "¡Sí, acéptalo!",
    "account": "Cuenta",
    "accountNumber": " Nombre de cuenta",
    "actions": "Acciones",
    "activateMessage": "¡Activarás a esta usuaria!",
    "activateMessageAdmin": "¡Activarás este usuario administrador!",
    "activateMessageReseller": "¡Activarás este revendedor!",
    "add": "Añadir",
    "address": "Dirección",
    "admin": "Administrador",
    "alerts": "Alertas",
    "alertSp": "Notificaciones de cumplimiento",
    "all": "Todo",
    "annotation": "Anotación",
    "assignedDriver": "Conductor asignado",
    "assignedVehicle": "Vehículo asignado",
    "atleast2Chars": "Por favor ingrese al menos 2 caracteres.",
    "atleast4chars": "Por favor, no escribas menos de 4 caracteres.",
    "authenticate": "Autenticar",
    "authenticateMFA": "Autenticar",
    "back": "atrás",
    "backToList": "Volver a la lista",
    "breadcrumb": "Filtros Aplicados:",
    "bulkDownloadReport": "Informes de descarga masiva",
    "businessAddress": "Dirección comercial",
    "camera": "Cámara",
    "updateCard": "Update Credit Card",
    "paymentInfo": "Billing Information",
    "cameraPassword": "Contraseña de la cámara",
    "cameraSerialNo": "Número de serie de la cámara",
    "cameraStatus": "Estado de la cámara",
    "cameraUrlNotFound": "Your account is not registered in Camera portal. Please register in camera portal and try again.",
    "cancel": "Cancelar",
    "cardDetails": "Detalles de la tarjeta actualizados con éxito",
    "carrierName": "Portador",
    "cellPhone": "Teléfono celular",
    "choosePortal": "Elige Portal",
    "city": "Ciudad",
    "claimAdjuster": "Ajustador de reclamos",
    "clear": "Borrar",
    "clearAll": "Borrar todo",
    "coDriver": "Copiloto",
    "coDriverId": "coDriverId",
    "company": "Compañía",
    "companyType": "Tipo de empresa",
    "confirm": "Confirmar",
    "confirmPassword": "Confirmar Contraseña",
    "confirmPasswordMessage": "Por favor, introduzca el mismo valor de nuevo.",
    "contractLength": "Duración del contrato",
    "createAdmin": "Administrador creado exitosamente",
    "createResellerUser": "Usuario revendedor creado exitosamente",
    "currentOdometer": "Cuentakilómetros actual",
    "customerName": "Nombre del cliente",
    "customPolicyTemplate": "Haga clic para ver la plantilla de política personalizada",
    "cycleRule": "Regla de ciclo",
    "dataImportSuccess": "Los datos se han importado correctamente",
    "date": "Fecha",
    "dateFrom": "Fecha desde",
    "datePicker": "mm/dd/yyyy",
    "dateTo": "Fecha a",
    "delete": "Eliminar",
    "deleteAdminResellerInfo": "Esta acción no se puede deshacer.",
    "deleteDepartment": "Departamento eliminado correctamente",
    "deletePopup": "¡Sí, elimínalo!",
    "deleteRegion": "Región eliminada correctamente",
    "deleteTerminal": "Terminal eliminado exitosamente",
    "deleteUserAdminReseller": "¿Está seguro de que desea eliminar el usuario revendedor?",
    "department": "Departamento",
    "departmentAdded": "Departamento agregado correctamente",
    "departments": "Departamentos",
    "departmentUpdated": "Departamento actualizado correctamente",
    "description": "Descripción",
    "deviceSn": "Dispositivo SN",
    "deviceType": "Tipo de dispositivo",
    "disableMFA": "Deshabilitar MFA",
    "disablePopup": "Sí, desactivar",
    "discount": "Descuento %",
    "distance": "Distancia",
    "document": "Documento",
    "documents": "Documentos",
    "dotNumber": "Número de DOT",
    "dotOfficerCode": "DOT Código de oficial",
    "driver": "Conductor",
    "driverId": "driverId",
    "driverName": "Nombre del conductor",
    "driverNamejobName": "Nombre del trabajo",
    "driverPhone": "Teléfono del conductor",
    "drivers": "Conductor",
    "drivingState": "Estado de conduccion",
    "edit": "Editar",
    "email": "Correo Electrónico",
    "emailValidationMessage": "Por favor ingrese un formato de Correo Electrónico válido",
    "employeeId": "ID de empleado",
    "en": "English",
    "enableMFA": "Habilitar MFA",
    "enablePopup": "Sí, habilitar",
    "endTime": "Fin del tiempo",
    "es": "Spanish",
    "export": "Exportar",
    "exportAll": "Exportar todo",
    "exportData": "Exportar datos",
    "failed": "No se pudo actualizar",
    "fieldRequiredMessage": "Este campo es obligatorio",
    "filterRequiredMessage": "Please select atleast one filter",
    "finish": "Terminar",
    "firstName": "Nombre",
    "fleetManager": "Gestor de flota",
    "fleetManagerDefault": "Gestor de flota (defecto)",
    "fleetopsUrlNotFound": "This feature is not configured for your account.",
    "fromLocation": "Desde",
    "fullName": "Nombre completo",
    "fullname": "Nombrecompleto",
    "geocodedLocation": "Ubicación geocodificada",
    "gvw": "GVW or Peso total de vehículo",
    "hardwareDevice": "Dispositivo de hardware",
    "hideNotification": "Ocultar notificación",
    "hireDate": "Fecha de contratación",
    "history": "Historia",
    "hours": "Horas",
    "hoursDriving": "Horas de conducción",
    "hoursWorked": "Horas Trabajadas",
    "import": "Importar",
    "importUser": "Importar usuario",
    "isValidVin": "El número VIN debe tener 17 caracteres de longitud. Números y letras solamente. I, O o Q no están permitidos",
    "language": "Idioma",
    "lastname": "Apellido",
    "lastName": "Apellido",
    "licenceNumber": "Número de licencia",
    "liveCamera": "Transmisión en vivo",
    "location": "Ubicación",
    "locationAdded": "Ubicación agregada correctamente",
    "locationDeleted": "Ubicación eliminada correctamente",
    "locationOfLogSigning": "Ubicación de la firma del registro",
    "locationUpdated": "Ubicación actualizada correctamente",
    "logbookDetails": "Registro diario de {{name}} para el",
    "logsHistory": "Historial de Registro Diario",
    "lossControl": "Control de pérdidas",
    "mainAddress": "Dirección principal",
    "mainInformation": "INFORMACION PRINCIPAL",
    "make": "Marca",
    "manageAdmin": "Administrar administrador",
    "manageDailyDocuments": "GESTIONAR DOCUMENTOS DIARIOS",
    "manageSubscription": "Gestionar suscripción",
    "max30Chars": "Máximo permitido 50 caracteres.",
    "maxChar": "máximo 50 caracteres",
    "maxValueMessage": "máximo 100%",
    "mechanic": "Mecánico",
    "message": "Mensaje",
    "mfacode": "código MFA",
    "minChar": "mínimo un carácter requerido",
    "minimumRow": "Se requiere un mínimo de 1 fila",
    "minValueMessage": "mínimo 0%",
    "modifiedBy": "Modificado por",
    "mph": "MPH",
    "name": "Nombre",
    "next": "Siguiente >>",
    "nextMaintenanceDate": "Siguiente fecha de mantenimiento",
    "nextMaintenanceMileage": "Siguiente mantenimiento Kilometraje",
    "no": "No",
    "noBreadcrumbData": "No se encontraron datos para trazar el BreadCrumb",
    "noData": "Nada que mostrar",
    "noDataToPlot": "Sin datos",
    "noDuplicateEmail": "No se permiten correos electrónicos duplicados sobre accidentes.",
    "noMoreThan9": "Por favor, no escribas mÃ¡s de 9 caracteres.",
    "note": "Nota",
    "notes": "Notas",
    "notificationList": "Lista de notificación",
    "ok": "OK",
    "otherContact": "Otro contacto",
    "pageNotFound": "Página no encontrada",
    "partAdded": "Piezas agregadas correctamente",
    "password": "Contraseña",
    "passwordIsNotMatching": "La contraseña de confirmación no coincide con la contraseña",
    "passwordValidMessage": "Password must have at least an uppercase character, a lowercase character, a digit, a special character, at least 6 characters and at most 15 characters long.",
    "paymentName": "Nombre en la tarjeta",
    "paymentplaceholder": "Jane Doe",
    "pdf": "PDF",
    "phone": "Número de teléfono",
    "phoneNumber": "Número de teléfono",
    "photos": "Fotos",
    "plateNumber": "Número de placa",
    "pleaseSelect": "Por favor, seleccione",
    "policiesAndProcedures": "Políticas y procedimientos",
    "policy": "Política",
    "popupMessage": "¡No podrás recuperar a esta usuaria!",
    "popupMessageAdmin": "¡Estás desactivando este usuario administrador!",
    "popupMessageReseller": "¡Estás desactivando esta revendedor!",
    "positiveNumberMessage": "Debe ser mayor que cero",
    "previous": "<< Anterior",
    "privacyPolicy": "Privacy Policy",
    "proceedToAdd": "Proceder a agregar",
    "proceedToImport": "Proceder a importar",
    "producerCode": "Código de revendedor",
    "qrCode": "Introducir código",
    "radiusSection": "Configuración de radio",
    "radiusTolerance": "Tolerancia del radio",
    "recoverConfirm": "¡No podrás recuperar este Vehiculos!",
    "refresh": "Actualizar",
    "regeneratePdf": "Regenerar PDF",
    "region": "Región",
    "removeMFA": "Eliminar MFA",
    "reported": "Reportado",
    "Reseller": "Revendedor",
    "resellerCreate": "Revendedor creado con éxito",
    "resellerUpdate": "Revendedor actualizado exitosamente",
    "reset": "Reiniciar",
    "role": "Función",
    "save": "Guardar",
    "saveChanges": "Guardar cambios",
    "saveRegion": "Región agregada exitosamente",
    "search": "Buscar",
    "searchBox": "Buscar...",
    "searchReseller": "Buscar...",
    "searchSubReseller": "Buscar...",
    "select": "Seleccionar",
    "send": "Enviar",
    "serviceCenter": "Centro de servicio",
    "serviceManager": "Gerente de Servicio",
    "setUpMFA": "Configurar MFA",
    "shipDocs": "Documentos De Embarcación",
    "show": "Espectáculo",
    "SHOW": "Espectáculo",
    "startTime": "Hora de inicio",
    "state": "Estado",
    "status": "Estado",
    "subject": "Sujeto",
    "submit": "Enviar",
    "subResellerCreate": "Subrevendedor creado exitosamente",
    "subResellerUpdate": "Subrevendedor actualizado exitosamente",
    "successfull": "Exitoso",
    "summary": "Resumen",
    "superAdmin": "Super Admin",
    "sureConfirm": "¿Está seguro?",
    "sureDeleteRequest": "¿Está seguro de que desea eliminar esta solicitud?",
    "syncData": "Sincronizar datos",
    "tableEmptyMessage": "No hay datos disponibles en la tabla",
    "template": "Modelo",
    "terminal": "Terminal",
    "terminalAdd": "Terminal agregado con éxito",
    "terminalAddress": "Dirección de terminal",
    "terminalUpdate": "Terminal actualizado con éxito",
    "termsValidation": "Por favor acepte los términos y condiciones para continuar",
    "testCompany": "Empresa de prueba",
    "timeZone": "Su zona horaria no se puede obtener de la dirección ingresada. Por favor seleccione su zona horaria a continuación:",
    "timezone": "Zona horaria",
    "timeZoneOffsetFromUTC": "Desplazamiento de zona horaria desde UTC",
    "toLocation": "Hasta",
    "tools": "Herramientas",
    "total": "Total",
    "totalDistance": "Distancia total",
    "totalHoursWorked": "Total de horas trabajadas",
    "trailer": "Remolque",
    "trailerInformation": "Información del remolque",
    "trailerList": "Lista de remolques",
    "trailerName": "Remolques",
    "truckId": "ID del camión",
    "type": "Tipo",
    "unAuthorized": "Sin autorización",
    "underWriter": "Asegurador",
    "unhandled": "No manejado",
    "update": "Actualizar",
    "updateAdmin": "Administrador actualizado exitosamente",
    "updatedTime": "Hora actualizada",
    "updateRegion": "Región actualizada correctamente",
    "updateResellerUser": "Usuario revendedor actualizado exitosamente",
    "upgrade": "Mejorar",
    "upload": "Subir a",
    "usdotDetails": "USDOT No ha sido eliminado",
    "user": "Usuario",
    "userCredentials": "CREDENCIALES DE USUARIO",
    "userInformation": "Información del usuario",
    "userMainInformation": "INFORMACIÓN PRINCIPAL DEL USUARIO",
    "userName": "Nombre de usuario",
    "validLicenseNumber": "El número de licencia debe contener únicamente caracteres alfanuméricos.",
    "validName": "Por favor introduzca no más de 10 caracteres",
    "validNumberMessage": "Por favor ingresa un número válido",
    "validNumFormat": "Complete el formato correcto (844-636-1360).",
    "vehicle": "Vehículo",
    "vehicleId": "Identificación del vehículo",
    "vehicleInformation": "Información del vehículo",
    "vehicleList": "Lista de vehículos",
    "vehicleName": "Nombre del Vehículo",
    "vehicles": "Vehículos",
    "version": "Versión",
    "view": "Ver",
    "viewLess": "Ver menos",
    "viewMore": "Ver más",
    "webfleetProvider": "Proveedor de flotas web",
    "WFConnect": "Información de la cuenta de WF.connect",
    "yes": "Yes",
    "zipCode": "Código Postal",
    "noteDesc": "Notas Descripción",
    "updatedBy": "Actualizado por",
    "updatedOn": "Actualizado el",
    "saveNote": "Guardar notas",
    "searchText": "Buscar...",
    "companyTierChange": "Do you want to assign reseller default tier ({{defaultTier}}) to current company subscription Tier ({{currentTier}})?",
    "companyTierChangeText": "Do you want to assign reseller default tier to current company subscription Tier?",
    "resellerAddTierChange": "Do you want to assign parent reseller default tier ({{defaultTier}}) to current reseller ({{currentTier}})?",
    "resellerAddTierChangeText": "Do you want to assign parent reseller default tier to current reseller?",
    "resellerEditTierChange": "Do you want to change current reseller tier ({{currentTier}}) with parent reseller tier ({{defaultTier}})?",
    "resellerEditTierChangeText": "Do you want to change current reseller tier with parent reseller tier?",
    "configuration": "Configuration",
    "emailAlerts": "Email Alerts",
    "alertToEmailInfo": "If no events are selected, it will be considered that all events should be sent.",
    "lastUpdated": "Última actualización",
    "viewAll": "Ver todo",
    "followVehicle": "Seguir vehículo",
    "validName10000": "maximum 10000 allowed",
    "timzone": "Zona horaria",
    "cameraTypeChangeWarning": "You are changing camera type to {{camerType}}. This will reset the current camera serial number and password",
    "max20Char": "Maximum character limit exceeds.",
    "max60Char": "Maxmium 60 character allowed",
    "onlyletterNumber": "Only letters and numbers are allowed"
  },
  "serviceRequest": {
    "pendingMechanic": "Mecánico pendiente",
    "pendingDriver": "Conductor pendiente",
    "completed": "Completado",
    "manageServiceRequest": "Gestionar solicitudes de servicio"
  },
  "alerts": {
    "activated": "¡Activado con éxito!",
    "deactivated": "¡Desactivado con éxito!"
  },
  "errorTexts": {
    "max120Char": "Por favor, ingrese un máximo de 120 caracteres.",
    "max50Char": "Por favor, ingrese un máximo de 50 caracteres."
  },
  "avatarMenu": {
    "switchToOld": "Cambiar a vista anterior",
    "switchToNew": "cambiar a nueva vista",
    "messaging": "Mensajería",
    "logout": "Cerrar sesión"
  },
  "bulkDelete": {
    "alertSuccess": "Los datos se han importado con éxito. Estas cámaras han sido reasignadas.",
    "deleteError": "Ocurrió un error al eliminar",
    "imported": "Los datos se han importado con éxito.",
    "deleteVehicle": "¿Desea eliminar los vehículos con los siguientes VIN?",
    "allSuccess": "Éxito",
    "deleted": "Following {{count}} vehicles are deleted."
  },
  "leftMenu": {
    "accidents": "Acidentes",
    "accountReport": "Informe de cuentas",
    "alerts": "Alertas de cámara",
    "Audit": "Auditoría",
    "camera": "Cámara",
    "cameraAlerts": "Camera Alerts",
    "churnReport": "Churn Report",
    "companies": "Empresas",
    "companyData": "Datos de la Compañia",
    "csaViolation": "Violaciones de CSA",
    "dailyDocuments": "Documentos diarios",
    "dailyLogs": "Administrar registros diarios",
    "dashboard": "Panel de control",
    "dataUsage": "Uso de datos",
    "debugLogs": "Registros de depuración",
    "department": "Departamentos",
    "developerRequests": "Solicitudes de desarrollador",
    "documents": "Documentos",
    "DOTAudit": "Auditoría DOT",
    "feedback": "Comentarios",
    "filters": "Filtros",
    "fmcsaTitle": "Respuestas de la FMCSA",
    "fmcsaTitleList": "Listado FMCSA",
    "freight": "Transporte",
    "fuelReport": "Reporte sobre el consumo de combustible",
    "IFTAReport": "Informe IFTA",
    "inspections": "Inspeciones",
    "logs": "Registros",
    "policiesProcedures": "Políticas y procedimientos",
    "repairMaintenance": "Reparos y Mantenimiento",
    "reports": "Reportes",
    "resellers": "Revendedores",
    "revenueReport": "Informe de ingresos",
    "scoreCard": "Tarjeta de puntuación",
    "serviceRequest": "Solicitud de servicio",
    "serviceRequests": "Solicitudes de servicio",
    "subResellers": "Subrevendedores",
    "subscription": "Suscripción",
    "trailerList": "Lista de remolques",
    "trailers": "Remolques",
    "USDOT": "USDOT No. Gestión",
    "userReports": "Informes de usuario",
    "users": "Usuarios",
    "vehicleList": "Lista de vehículos",
    "vehicles": "Vehículos",
    "wlBilling": "Facturación WL",
    "wlBillingInfo": "Información de facturación de WL"
  },
  "dashboard": {
    "udNotification": "Tiene tiempo de conducción no identificado no asignado. Vaya a la pestaña de registros y asigne estos registros al controlador correcto.",
    "driverStatus": {
      "DRIVING": "USUARIOS ADMINISTRACION - DRIVING",
      "ON_DUTY": "USUARIOS ADMINISTRACION - ON DUTY",
      "SLEEPER_BERTH": "USUARIOS ADMINISTRACION - SLEEPER",
      "OFF_DUTY": "USUARIOS ADMINISTRACION - OFF DUTY"
    },
    "notInUseVehicles": {
      "pageHeading": {
        "INSHOP": "ADMINISTRAR VEHÍCULOS - IN SHOP",
        "OUTOFSERVICE": "ADMINISTRAR VEHÍCULOS - OUT OF SERVICE"
      },
      "listHeading": {
        "INSHOP": "List Of Vehicles In Shop",
        "OUTOFSERVICE": "List Of Vehicles Out Of Service"
      }
    },
    "tabs": {
      "driverBehavior": "Comportamiento del conductor",
      "vehicleStatus": "Estado del Vehiculos",
      "dailyLogs": {
        "heading": "Registros diarios"
      },
      "driverStatus": {
        "heading": "Estado del conductor",
        "lastKnownLocation": "Última ubicación conocida",
        "unit": "Unidad",
        "driveTimeRemaining": "Tiempo de conducción restante",
        "timeUntilBreak": "Tiempo hasta el descanso",
        "onDutyTimeRemaining": "Tiempo restante de servicio",
        "dutyCycleRemaining": "Ciclo de trabajo restante",
        "currentStatus": "Estado actual",
        "engineSpeed": "La velocidad del motor",
        "lastUpdated": "Última actualización",
        "eld": "ELD"
      },
      "potentialViolations": {
        "heading": "Posibles infracciones",
        "pageHeading": "GESTIONAR LAS VIOLACIONES",
        "violationType": "Tipo de infracción"
      },
      "radiusComplianceAlerts": {
        "company": "Nombre del titular de la póliza",
        "radius": "Radius",
        "type": "Type",
        "radiusExperience": "Radius Experience",
        "description": "Descripción",
        "date": "Fecha",
        "overage": "Exceso",
        "monthInViolation": "Mes en violación",
        "lossControl": "Control de pérdidas",
        "underwriter": "Underwriter"
      },
      "radius": "Radius",
      "severity": "Severity",
      "csaSnapshot": "Instantánea CSA",
      "recentAccidents": "Accidentes recientes",
      "developerRequests": "Solicitudes de permiso de desarrollador",
      "overview": "Overview",
      "alerts": {
        "enableNotification": "Habilitar la notificación",
        "heading": "Alertas"
      }
    },
    "header": {
      "TOTALDRIVERS": "Total de conductores activas",
      "ONDUTY": "De turno",
      "DRIVING": "Conducción",
      "SLEEPER": "Durmiente",
      "OFFDUTY": "Fuera de servicio",
      "TOTALTRUCKS": "Camiones totales",
      "AVAILABLETRUCKS": "Camiones Disponibles",
      "INSHOP": "En tienda",
      "OUTOFSERVICE": "Fuera de servicio",
      "text": "Resumen de la empresa"
    },
    "potentialViolations": {
      "heading": "Violaciones Potenciales",
      "pageHeading": "Notifications",
      "violationType": "Tipo de infracción"
    }
  },
  "api": {
    "errors": {
      "noService": "Servicio temporalmente no disponible",
      "networkError": "Error de servidor interno"
    }
  },
  "resellers": {
    "addHeading": "Agregar revendedor",
    "editHeading": "Detalles del revendedor",
    "listHeading": "Gestionar revendedores",
    "listSubResellerHeading": "Gestionar subrevendedores",
    "code": "Código",
    "joinedDate": "Fecha de ingreso",
    "trucksCount": "Número de camiones",
    "path": "ruta"
  },
  "companies": {
    "listHeading": "Gestionar Empresas",
    "company": "Empresa",
    "dot": "DOT #",
    "activeTrucks": "Camiones activos",
    "payment": "DETALLES DE PAGO",
    "contractLength": "Duración del contrato",
    "contractExpiration": "Vencimiento del contrato",
    "registrationDate": "Fecha de registro",
    "status": "Estado",
    "producerCode": "Código de revendedor",
    "producerName": "Nombre del revendedor",
    dot: 'ID de cotización'
  },
  "chat": {
    "sendMessage": "Enviar un mensaje",
    "selectDriver": "A: Buscar...",
    "newConvo": "Nueva conversación",
    "broad": "Emisión",
    "search": "Buscar...",
    "type": "Escribe"
  },
  "users": {
    "listHeading": "Administrar usuarios",
    "addHeading": "AGREGAR USUARIO",
    "editHeading": "Detalles del usuario",
    "vehicleForMechanic": "Vehículo para el mecánico",
    "vehicleForDriver": "Vehículo para el conductor",
    "enableYardMoves": "Habilitar movimientos de patio",
    "enableNonDOTTrip": "Habilitar viaje sin DOT",
    "enablePersonalConveyance": "Habilitar transporte personal",
    "aGExemption": "Exención de AG",
    "exemptFromUsingELD": "Exento de utilizar el ELD",
    "expirationDate": "Fecha de caducidad",
    "selectFileToUpload": "Seleccione el archivo para cargar",
    "resetPasswordHeading": "RESTABLECER LA CONTRASEÑA",
    "profileHeading": "EDITAR PERFIL",
    "All": "Todos",
    "admins": "Administradores",
    "drivers": "Conductores",
    "mechanics": "Mecánicos",
    "driverStatusHistory": "Historial de estado del conductor",
    "fleetManager": "Gestor de flota",
    "joined": "Unido",
    "addNewUser": "Agregar nuevo usuario",
    "quickFilter": "Filtros rápidos:",
    "DVIROnly": "Solo DVIR",
    "addDriver": "Agregar conductor",
    "addNewDriver": "Agregar nuevo conductor",
    "adminUsers": "Usuarios administradores",
    "bigDayShortHaul": "Gran día de corto recorrido",
    "claimManagers": "Ajustadores de reclamaciones",
    "fleetUsers": "Usuarios de flota",
    "lossControllers": "Controles de pérdidas",
    "mechanicListHeading": "Gestionar mecánicos",
    "resellerUsers": "Usuarios de revendedores",
    "searchMechanic": "Buscar mecánico",
    "serviceManagers": "Gerentes de servicio",
    "underWriters": "Suscriptores",
    "userInfo": "Información del usuario"
  },
  "logs": {
    "manageLogsHeader": "ADMINISTRAR REGISTROS",
    "undefinedDriverHeader": "REGISTROS DE CONDUCTORES NO IDENTIFICADOS",
    "addLogHeader": "AGREGAR REGISTROS",
    "dailyLogExportMessage": "Exportar el estado firmado del registro diario",
    "logBook": "Libro de registro",
    "unassignedDriveTime": "Tiempo de manejo no asignado",
    "logs": "Registros",
    "unidentifiedDriverProfile": "Perfil del conductor no identificado",
    "dateInUtc": "Fecha (en UTC)",
    "viewDocument": "Ver documentos",
    "noViolation": "No hay datos de violación para el día",
    "history": "Historial de Registro Diario",
    "editHeading": "EDITAR REGISTRO DIARIO",
    "addHeader": "Información del usuario",
    "codriver": "Nombre del copiloto",
    "logLocation": "Ubicación de firma de registro",
    "violations": "Violaciones",
    "status": "Estado",
    "stateModifier": "Modificador de estado",
    "timeFrom": "Tiempo desde",
    "timeTo": "Tiempo hasta",
    "location": "Ubicación",
    "assignedDriver": "Conductor asignado",
    "notes": "Notas",
    "addNewRow": "Agregar nueva fila",
    "Submit": "Guardar",
    "UpdateEvents": "Actualizar eventos",
    "UpdateGraph": "Actualizar gráfico",
    "noDataMessage": "Solicitud no válida. Haga clic aquí para volver al panel",
    "backToDashboard": "regresa",
    "archiveLogsHeader": "REGISTROS ARCHIVAAOS",
    "manageLogsHeaderSigned": "Registros Firmados",
    "manageLogsHeaderUnSigned": "Registros en tiempo real/No asignados",
    "allDutyTimeTracker": "Informe de seguimiento de todo el tiempo de servicio,",
    "oildFieldWaiting": "Oil Field Waiting",
    "spireonTitle": "Daily Logs"
  },
  "vehicles": {
    "activateIt": "¡Sí, actívalo!",
    "addHeading": "AÑADIR VEHÍCULO",
    "editHeading": "Editar vehículo",
    "fullName": "Nombre completo",
    "role": "Función",
    "email": "Correo Electrónico",
    "empId": "Emp Id",
    "deactivateResellerUser": "Yes, deactivate!",
    "deactivateUser": "¡Sí, desactivar usuario!",
    "deleteReseller": "Yes, Delete!",
    "deleteUser": "Yes, Delete!",
    "drivers": "Conductores",
    "exportUser": "Exportar usuarios",
    "fuelType": "Fuel Type",
    "importUserTemplate": "Importar usuario",
    "lastLogin": "Última conexión",
    "listHeading": "ADMINISTRAR VEHÍCULOS",
    "manufact": "Manufact",
    "manufacturer": "Fabricante",
    "model": "Modelo",
    "searchUser": "Buscar usuario",
    "searchVehicle": "Buscar Vehículo",
    "searchVehicleTrailer": "Buscar Vehículo / remolque",
    "type": "Tipo",
    "unitId": "Identificación de la unidad",
    "users": "Usuarios",
    "vehicleType": "Tipo de vehículo",
    "vin": "VIN",
    "wlId": "CRM ID",
    "year": "Año",
    "nextMaintenanceDate": "Next Maintenance Date",
    "nextMaintenanceMileage": "Next maintenance Mileage",
    "camera": "Camera",
    "currentOdometer": "Current Odometer",
    "notes": "Notes",
    "deviceType": "Device type",
    "hardwareDevice": "Hardware Device",
    "deviceSn": "Device Serial No:",
    "trailerName": "Trailer",
    "plateNumber": "Plate Number",
    "make": "Make",
    "gvw": "GVW",
    "assignedVehicles": "Vehículos asignados",
    "tabs": {
      "listVehicles": "Lista de Vehículos",
      "listTrailers": "Listado de remolques",
      "roadInspection": "Inspecciones en el camino"
    },
    "addVehicle": "Agregar vehiculo",
    "addTrailer": "Agregar remolque",
    "importVehicleTemplate": "Plantilla de Vehiculoss de importación",
    "importTrailerTemplate": "Plantilla de importación de trailers",
    "trackVehicle": "Seguimiento del vehículo",
    "dateTimeFrom": "Fecha/Tiempo desde",
    "dateTimeTo": "Fecha/Hora de",
    "exportVehicle": "Exportar Vehículos",
    "exportTrailer": "Exportar trailers",
    "seatBeltStatus": "Estado del cinturón de seguridad",
    "importVeh": "Importar vehículos",
    "importTra": "Importar tráilers",
    "mechanics": "Mecánica"
  },
  "reports": {
    "downloadReports": "Descargar reportes"
  },
  "accidents": {
    "heading": "DIRIGIR LOS ACCIDENTES",
    "witnessStatement": "Declaracion de testigo",
    "accidentReport": "Reporte de accidente",
    "dateAndTime": "Fecha y hora",
    "viewWitness": "Ver Testigos",
    "viewReport": "Vista del informe",
    "viewReceipt": "Ver recibos"
  },
  "eld": {
    "all": "Todas",
    "delivery_receipts": "Recibo de entrega",
    "dispatch_records": "Dispatch Record",
    "bills_of_landing": "Guía de carga",
    "receipts": "Copia del recibo",
    "weigh_tickets": "Boleto de pesaje",
    "communication_records": "Registro de comunicación",
    "other_documents": "Otro documento"
  },
  "documents": {
    "listHeading": "Documentos"
  },
  "developerRequests": {
    "listHeading": "Solicitudes de permiso de desarrollador",
    "developerName": "Nombre del desarrollador"
  },
  "departments": {
    "terminalsAndDepartments": "TERMINALES Y DEPARTAMENTOS",
    "noLocations": "Ninguna ubicación agregada",
    "noDepartments": "No hay departamentos bajo esta terminal",
    "addTerminal": "Agregar terminal",
    "editTerminal": "Editar terminal",
    "addRegion": "Agregar región",
    "editRegion": "Editar región",
    "regionName": "Nombre de la región",
    "fleetManagers": "Gestor de flota",
    "dot": "Dot #",
    "addDepartment": "Agregar departamento",
    "editDepartment": "Editar departamento",
    "addLocation": "Añade una ubicación",
    "editLocation": "Editar ubicación",
    "addFilter": "Set Filter",
    "deleteDepartment": "Delete Department",
    "deleteTerminal": "Delete Terminal",
    "filter": "Filters",
    "serviceCenters": "Service Centers",
    dot: 'ID de cotización',
  },
  "registration": {
    "companyInfoHeading": "INFORMACIÓN SOBRE LA COMPAÑÍA",
    "userInfoHeading": "INFORMACIÓN DEL ADMINISTRADOR DE LA FLOTA",
    "initialTrucks": "Número de vehículos",
    "maintenancePeriod": "Período de mantenimiento (meses)",
    "maintenanceMileage": "Mantenimiento de Millaje",
    "subscriptionTier": "Nivel de suscripción",
    "contractLength": "Duración del contrato (años)",
    "createAccount": "Crear una cuenta",
    "producerCode": "Código del productor",
    "iAgree": "Estoy de acuerdo con la",
    "termsOfUse": "Términos de Uso",
    "totalAmount": "Cantidad total:$",
    "paymentConfirmation": "CONFIRMACIÓN DE PAGO",
    "noOfTrucks": "Cantidad de camiones",
    "costperTruck": "Costo por camión ($)",
    "salesTax": "Sales Tax ($)",
    "discount": "Descuento (%) (si corresponde)",
    "total": "Cantidad total ($)",
    "confirm": "Confirmar",
    "accept": "Aceptar",
    "iAcceptAll": "Acepto los siguientes términos y condiciones."
  },
  "csaViolation": {
    "listHeading": "VIOLACIONES DE CSA",
    "dvirLink": "Enlace DVIR",
    "dvirStatus": "Estado de DVIR",
    "roadsideDot": "Inspección DOT en carretera",
    "workOrder": "Orden de trabajo",
    "workOrderStatus": "Estado de la orden de trabajo",
    "oos": "OOS",
    "severity": "Gravedad"
  },
  "iftaMileage": {
    "listHeading": "KILOMETRAJE IFTA",
    "search": "Buscar",
    "notLessThanZero": "Meter reading should not be less than zero",
    "tooltip": "Descargar Truck GPS history",
    "hideLabel": "Ocultar estados sin kilometraje",
    "activeVehicles": "Vehículos activos",
    "deactivateVehicles": "Vehículos desactivados",
    "odometer": "Calcule desde el odómetro",
    "totalMiles": "Millas totales",
    "totalTaxableMiles": "millas totales sujetas a impuestos",
    "truck": "Camión",
    "Jurisdiction": "Jurisdicción",
    "JurisdictionLocation": "Jurisdiction/Location"
  },
  "fuelConsumption": {
    "pageHeading": "REPORTE SOBRE EL CONSUMO DE COMBUSTIBLE",
    "search": "Informe de búsqueda por vehículo",
    "currentDrivers": "Conductores Actuales",
    "location": "La última ubicación de abastecimiento de combustible",
    "Jurisdiction": "Jurisdicción",
    "miles": "Millas por galón",
    "history": "Historial de recargas",
    "unknown": "Desconocido"
  },
  "refillsHistory": {
    "pageHeading": "HISTORIA DE RECAMBIOS",
    "odometer": "Odómetro",
    "Jurisdiction": "Jurisdicción",
    "gallons": "Galones",
    "fuelAmount": "Cantidad de combustible (Galones)",
    "cost": "Costo total"
  },
  "usDotManagement": {
    "pageHeading": "PÁGINA DE GESTIÓN DE NÚMERO DE USDOT",
    "search": "Buscar USDOT No",
    "usDotNo": "USDot No.",
    "carrierName": "Nombre del operador",
    "mainAddress": "Dirección principal de la oficina",
    "zip": "Código postal",
    "addDot": "AGREGAR NUEVO DOT",
    "editDot": "EDITAR DOT",
    "message": "Mensaje",
    "send": "Enviar"
  },
  "inspections": {
    "listHeading": "Gestionar inspecciones",
    "user": "Búsqueda por usuario",
    "vehicle": "Buscar por vehículo",
    "inspectionType": "Tipo de inspección",
    "inspectionReport": "Reporte de inspección",
    "advancedDvir": "DVIR avanzado",
    "bulkDownloadReport": "Informes de descargas masivas",
    "dvirError": "Configuration type or section name not entered",
    "viewReport": "Vista del informe",
    "customDvir": "DVIR personalizado",
    "hasDefects": "Has Defects?",
    "advancedInput": "Section",
    "assetsCount": "Assets Count",
    "assetsName": "Asset Name",
    "assetsType": "Assets Type",
    "listHeading1": "Inspections",
    "searchBycompany": "Search By Company",
    "searchByMechanic": "Search By Mechanic",
    "unitType": "Unit Type"
  },
  "companyData": {
    "addPageHeading": "Agregar Compañía",
    "advanceSettings": "Configuraciones Avanzadas",
    "assetsType": "Tipo de Activos",
    "cancelSubscription": "Cancelar suscripción",
    "companyName": "Compañía",
    "contactPerson": "Persona de Contacto",
    "contractExpirationDate": "Fecha de Vencimiento de Contrato",
    "currentSubscriptionCost": "Costo de Suscripción Actual",
    "defaultCycleRule": "Regla de ciclo predeterminada",
    "DVIR": "DVIR",
    "editPageHeading": "Editar Compañía",
    "enablecompanyCheckbox": "Habilitar campo petrolífero en espera",
    "exceptions": "Excepciones",
    "expiryDate": "Fecha de Expiración del Seguro",
    "fleetManagerInformation": "Información del Gestor de Flota",
    "garagingAddress": "Dirección de Almacenaje:",
    "homeTimeZone": "Zona Horaria Local",
    "Ifta": "IFTA",
    "insuranceSettings": "Insurance Settings",
    "invalidGaragingAddress": "No se pueden generar coordenadas con la dirección de almacenamiento proporcionada. Por favor proporcione una dirección más específica",
    "lossControl": "Control de Pérdidas",
    "maintainanceMileage": "Mantenimiento de Millaje",
    "maintainancePeriod": "Periodo de Mantenimiento",
    "maintainancePeriodMonth": "Periodo de Mantenimiento (meses)",
    "noOfTrucks": "Número de vehículos",
    "otherLocationAddress": "Otra dirección de ubicación",
    "otherLocationContactPerson": "Otra persona de contacto de ubicación",
    "otherLocationPhoneNumber": "Otro número de teléfono de la ubicación",
    "pageHeading": "DATOS DE LA COMPAÑIA",
    "paymentInformation": "Información del pago",
    "radiusCompliance": "Cumplimiento de Radio",
    "skipcompanyCheckbox": "Omitir búsqueda de filtro de vehículo",
    "underwriter": "Asegurador",
    "updateCardDetails": "Actualizar detalles de la tarjeta",
    "updateCreditCardDetails": "Actualizar los detalles de la tarjeta de crédito",
    "vehicleType": "Tipo de vehículo",
    "website": "sitio web"
  },
  "paymentInformation": {
    "listHeading": "DETALLES DEL PAGO",
    "contractExpiry": "FECHA DE EXPIRACIÓN DE CONTRATO",
    "companyInfo": "Company Info for ",
    "contractHistory": "Historia del contrato",
    "startDate": "Fecha de inicio del contrato",
    "contractLength": "Duración del contrato",
    "nextBilling": "Siguiente Fecha de facturación",
    "paymentHistory": "Payment History for ",
    "createdDate": "Fecha de creación",
    "paidDate": "Fecha de pago",
    "unitCount": "Unidad de cuenta",
    "cost": "Costo por unidad",
    "receipt": "Recibo de pago",
    "start": "Fecha de estado",
    "end": "Fecha final",
    "noOfDays": "No. de días",
    "status": "Estado de pago",
    "company": "Nombre de Empresa",
    "listHeadingPayment": "Detalles de pago",
    "paymentHistoryText": "Payment History",
    "paymentId": "Payment Id"
  },
  "workOrders": {
    "addHeading": "DETALLES DE LA ORDEN DE TRABAJO",
    "addWorkOrders": "Agregar orden de trabajo",
    "assignToServiceCeenter": "Assign to another Service Center",
    "assignWorkOrder": "Assign Service Request",
    "cause": "Porque",
    "closed": "Closed WorkOrders",
    "company": "Company",
    "concern": "Preocupación",
    "correction": "Corrección",
    "defectDetails": "Defect Details",
    "driver": "Driver",
    "dueDate": "Fecha de vencimiento",
    "dvirLocation": "DVIR Location",
    "engineOil": "Engine Oil Quantity",
    "fuel": "Fuel Quantity",
    "hydraulicOil": "Hydraulic Oil Quantity",
    "inspectionDetails": "DETALLES DE INSPECCIÓN",
    "inspectionReport": "INFORMES DE INSPECCIÓN",
    "laborCost": "Costo laboral ($)",
    "manageMechanics": "Manage Mechanics",
    "manageParts": "Administrar piezas",
    "mechanic": "Mecanicos",
    "noReport": "No informe",
    "notes": "Notas",
    "open": "Open WorkOrders",
    "pageHeading": "DIRIGIR LAS ORDENES DE TRABAJO",
    "parts": "Parts",
    "partsCost": "Costo ($)",
    "receipts": "INGRESOS",
    "repairCost": "Costo de Reparo ($)",
    "reportedDate": "Fecha reportada",
    "scheduled": "Programado",
    "scheduledDate": "Programado Fecha",
    "search": "busqueda de orden de trabajo",
    "serviceCenter": "Service Center",
    "serviceRequestEditSuccess": "Service Repair Request Has Been Updated.",
    "serviceType": "Tipo de Servicio",
    "status": "ESTADO",
    "totalCost": "Costo ($)",
    "unableToChangeStatus": "Service Request assigned to a service center. Unable to make this change!",
    "unavailable": "-",
    "unitType": "Unit Type",
    "vehicle": "Vehicle",
    "viewInspectionreport": "ver informe de inspeccion",
    "viewPhotos": "ver fotos",
    "viewPicture": "View Picture",
    "viewReceipt": "View Receipt",
    "viewReport": "Vista del informe",
    "windShieldFluid": "Windshield washer Quantity",
    "workOrderEditSuccess": "Work Order Has Been Updated.",
    "workOrderNo": "Orden de trabajo"
  },
  "suspended": {
    "listHeading": "SUSCRIPCIÓN",
    "buttonText": "Pagar con tarjeta",
    "title": "DETALLES DEL PAGO",
    "description": "Tienes un contrato activo de",
    "to": "hasta",
    "payButtonText": "AÑADIR DETALLES DE LA TARJETA",
    "expiredContract": "Su contrato ha expirado.",
    "saveButtonText": "Save"
  },
  "policies": {
    "ACCIDENT_INVESTIGATION": "Investigación de accidentes",
    "ALLOW_USING_PHONES": "Permitir el uso de Bluetooth",
    "chooseImage": "Por favor, elija un archivo .png o .jpg",
    "companyLogo": "Logotipo de la compañía",
    "CUSTOM_POLICY": "política personalizada",
    "customPolicies": "Custom Policies",
    "DISTRACTION_FREE_DRIVING": "Conducción sin distracciones",
    "DRESS_CODE": "Código de vestimenta",
    "DRIVER_SELECTION_MVR": "Conformidad con el historial de manejo",
    "DRIVING_TRAINING": "Formación de conductores",
    "heading": "Políticas y procedimientos",
    "INSPECTION": "Inspección",
    "LOSS_CONTROL_MANUAL_POLICY": "Manual de control de pérdidas",
    "mainInfo": "información principal",
    "MIN_DRIVER_AGE": "Edad mínima del conductor permitida",
    "MIN_HOURS": "Horas de formación obligatorias al año",
    "MIN_YEARS_ON_SIMILAR_EQUIPMENT": "Mínimo de años en equipos similares",
    "NUMBER_OF_ACCIDENTS_ALLOWED": "Número máximo de accidentes",
    "NUMBER_OF_CITATIONS_ALLOWED": "Número máximo de citaciones permitido",
    "PSP_USAGE": "Uso de la PSP",
    "SAFETY_PERSON_FULL_NAME": "Nombre completo del responsable de seguridad",
    "selectPolicies": "Seleccionar políticas",
    "TRAINING_DAYS": "Días de formación"
  },
  "dailyDocuments": {
    "receipt": "Copia del recibo",
    "users": "Usuarios",
    "documentType": "Tipo de Documento",
    "cusName": "Cliente/Nombre del trabajo",
    "uploadNewDoc": "Subir nuevo documento"
  },
  "popup": {
    "success": "Éxito"
  },
  "roadInspection": {
    "driverId": "Identificación del conductor",
    "defectFound": "Defecto encontrado"
  },
  "parts": {
    "pageHeading": "Manage Parts",
    "partName": "Parte",
    "partsInventory": "En inventario",
    "cost": "Costo ($)",
    "addPart": "Agregara pieza",
    "partTitle": "Piezas",
    "costError": "Ingrese un valor mayor o igual a 0"
  },
  "reportPage": {
    "allDutyTimeTracker": "Informe de seguimiento de todo el tiempo de servicio",
    "bayIndustriesPayroll": "Informe de nómina",
    "billOfLading": "Reporte sobre el conocimiento de embarque",
    "borderStates": "Reporte de tiempo del documento",
    "DailyFailedInspectionReport": "Reporte de inspección fallido",
    "DailyHocDriverViolation": "Reporte sobre las infracciones de las horas de servicio",
    "DailyUnidentifiedDrivingReport": "Reporte de conducción no identificado",
    "dailyUnsignedLogReport": "Reporte de registro sin firma",
    "driverPerf": "Reporte del rendimiento del conductor",
    "drivingEvents": "Reporte de evento de manejo",
    "dutyStatus": "Estado del servicio",
    "editedData": "Reporte de datos editados",
    "eldDisconn": "Reporte de desconexión del ELD",
    "hos": "Detalle de las infracciones de las horas de servicio",
    "malFunc": "Reporte de avería",
    "MonthlyHOSDriverViolationsReport": "Reporte mensual de infracciones de las horas de servicio de los conductores",
    "MonthlyUnsignedLogReport": "Reporte mensual de registro sin firma",
    "noOfRequestsPerDay": "No of Requests Per Day",
    "odoJump": "Reporte de salto de cuentakilómetros",
    "pastDueServiceRequests": "Past Due Service Requests",
    "pendingDriverDVIR": "Pending Driver DVIR",
    "pendingMechanic": "Pending Mechanic",
    "rejectedEdits": "Ediciones rechazadas",
    "unassigned": "Reporte de manejo no asignado",
    "violation": "Reporte de infracciones"
  },
  "potentialViolations": {
    "heading": "Violaciones Potenciales",
    "pageHeading": "Gestionar las infracciones",
    "violationType": "Tipo de infracción"
  },
  "trailers": {
    "deleteIt": "¡Sí, elimínalo!",
    "recoverConfirm": "No podra recuperar este trailer",
    "trailerType": "Tipo de remolque",
    "addHeading": "Agregar remolque",
    "editHeading": "Editar tráiler"
  },
  "graphTitles": {
    "hardAcceleration": "Aceleración dura",
    "hardDeceleration": "desaceleración dura",
    "speeding": "Exceso de velocidad",
    "hoursExceeding": "Horas de conducción excedidas",
    "fuelEconomy": "Economía de combustible",
    "nonBuckledSeatbelt": "Advertencia de cinturón de seguridad no abrochado",
    "hardTurn": "Giro dura"
  },
  "newScoreCard": {
   "last30Days": "Últimos 30 días",
   "currentPolicyPeriod": "Período actual de la póliza",
    "heading": "Resumen de la Tarjeta de Puntuación",
    "selectPeriod": "Seleccionar Período",
    "unpoweredDays": "Días Sin Funcionamiento",
    "driverBehavior": "Comportamiento del Conductor",
    "fleetScore": "Puntuación de la Flota",
    "radiusViolation": "Violación del Radio",
    "distractedDriving": "Conducción Distraída",
    "speeding": "Exceso de Velocidad",
    "contact": "Contacto",
    "totalVehicle": "Total de Vehículos"
  },
  "scorecard": {
    "driverBehavior": "Comportamiento del Conductor",
    "unpoweredDays": "Días Sin Funcionamiento",
    "unpoweredDaysDescription": "Basado en el número de días en que los camiones no estaban en funcionamiento. Menos días sin funcionamiento resultan en una puntuación más alta.<br/><br/><i>Método: 0.2 * Puntuación de Días Sin Funcionamiento</i>",
    "driverBehaviorDescription": "Calculado en base al número de eventos de conducción. La puntuación representa un comportamiento de conducción seguro, con menos eventos que llevan a una puntuación más alta.<br/><br/><i>Método: 0.6 * Puntuación de Comportamiento del Conductor</i>",
    "radiusViolations": "Violaciones del Radio",
    "radiusViolationsDesc": "Mide los días en que los camiones violaron el radio predefinido. Menos días de violación resultan en una puntuación más alta.<br/><br/><i>Método: 0.2 * Puntuación de Violación del Radio</i>",
    "total": "Total",
    "vehicle": "Vehículos",
    "driverBehaviorDesc": "Calculado en base al número de eventos de conducción en todos los camiones.<br/><br/><i>Método: 100 - (Suma de Eventos de todos los camiones / (Días Laborales Totales * Total de Camiones)) * 100.</i><br/><br />El gráfico circular muestra el número de camiones agrupados por sus porcentajes de rendimiento individuales, indicando cuántos camiones caen dentro de cada rango definido.",
    "actualScore": "Puntuación Actual",
    "distractedDriving": "Conducción Distraída",
    "accident": "Accidente",
    "speeding": "Exceso de Velocidad",
    "moreInfo": "Más Información",
    "unpoweredDaysGraphDesc": "Calculado en base al número de días en que los camiones no estaban en funcionamiento.<br/><br/><i>Método: 100 - (Suma de Días Sin Funcionamiento de cada camión / (Días Laborales Totales * Total de Camiones)) * 100.</i><br/><br />El gráfico circular muestra el número de camiones agrupados por sus porcentajes de rendimiento individuales, indicando cuántos camiones caen dentro de cada rango definido.",
    "unpoweredDaysTotalDesc": "El número acumulativo de días sin funcionamiento en todos los camiones de la flota",
    "radiusViolationGraphDesc": "Calculado en base al número de días en que los camiones violaron el radio predefinido.<br/><br/><i>Método: 100 - (Suma de Días de Violación de cada camión / (Días Laborales Totales * Total de Camiones)) * 100.</i><br/><br />El gráfico circular muestra el número de camiones agrupados por sus porcentajes de rendimiento individuales, indicando cuántos camiones caen dentro de cada rango definido.",
    "radiusViolationTotalDesc": "El número acumulativo de días de violación del radio en todos los camiones de la flota",
    "noDataText": "¡No hay datos disponibles!",
    "excellent": "Excelente",
    "good": "Bueno",
    "average": "Promedio",
    "belowAverage": "Por Debajo del Promedio"
  },
  "banner": {
    "tellUs": "¡Cuéntanos más sobre tu flota!",
    "haveCameraQ": "¿Tienes cámaras?",
    "haveInsuranceQ": "¿Quién es tu proveedor de seguros?",
    "yes": "Sí",
    "no": "No",
    "cameraProviderQ": "¿Quién es tu proveedor de cámaras?",
    "policyRenewQ": "¿Cuándo se renueva tu póliza?",
    "submit": "Enviar",
    "later": "Más tarde",
    "thankYou": "¡Gracias por tu respuesta!",
    "thankYouInfo": "Esta ventana desaparecerá en {{ count }} segundos",
    "close": "Cerrar",
    "email": "Dirección de correo electrónico",
    "phone": "Número de teléfono",
    "emailValidation": "Email must be a valid",
    "cameraProviderPlaceholder": "Por favor ingrese el nombre del proveedor de cámaras",
    "insuranceProviderPlaceholder": "Por favor ingrese el nombre de su proveedor de seguros (opcional)",
    "emailPlaceholder": "ejemplo@gmail.com",
    "phoneNumberPlaceHolder": "000-000-0000"
  },
  "scoreCard": {
    "heading": ":name Scorecard",
    "fleet": "Fleet",
    "policyHolderManagementScore": "Policy Holder Management Score",
    "policyHolderManagement": "Policy Holder Management",
    "address": "Address",
    "dotNumber": "DOT Number",
    "xDate": "X-Date",
    "date": "Report Date",
    "fleetManagement": "Fleet Management",
    "operatingTerritory": "Operating Territory",
    "fleetManagementScore": "Fleet Management Score",
    "vehicleInspectionScore": "Vehicle Inspection Score",
    "consistentEquipment": "Consistent Equipment",
    "vehicleComposition": "Vehicle Composition",
    "driverTurnOver": "Driver Turn Over",
    "driverTenure": "Driver Tenure (Years)",
    "quickStats": "Quick stats",
    "radiusCompliance": "Radius Compliance",
    "radiusTable": {
      "driverName": "Driver Name",
      "vehicle": "Vehicle",
      "radius": "Radius",
      "radiusExperience": "Radius Experience",
      "overage": "Overage",
      "date": "Date of Violation"
    }
  },
  "fmcsa": {
    "title": "Listado de FMCSA",
    "Reseller": "Revendedor",
    "driver": "Conductor",
    "vehicle": "Vehículo",
    "date": "Fecha",
    "file": "Archivo",
    "submissionId": "ID de Envío",
    "response": "Respuesta",
    "message": "Mensaje",
    "showMore": "Mostrar Más"
  }
}